import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { RCCGrid, RCCHookToast, RCCInput, RCCRefModalProps} from "react-common-components";
import { useForm } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";
import { getValidationErrors, standardErrorMessages } from "src/utils/errors";
import DeleteModal from "src/components/DeleteModal";
import { IRefFishBoneModals } from "./interface";
import addAndChangeSchema from "./schemas";

const FishBoneModals: React.ForwardRefRenderFunction<IRefFishBoneModals> = (_, ref) => {

	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();
	
	const [defaultCause, setDefaultCause] = useState<string>();
	const [title,setTitle] = useState<string>("");
	const [isAdd, setIsAdd] = useState(false);

	const modalAddOrChange = useRef<RCCRefModalProps>(null);
	const onCallback = useRef<Function | undefined>(undefined);
	const { 
		handleSubmit : handleSubmitAddOrChange, 
		register : registerAddOrChange, 
		reset : resetAddOrChange, 
		setError : setErrorAddOrChange, 
		formState: { errors : errorsAddOrChange }, 
		clearErrors: clearErrorsAddOrChange 
	} = useForm();
	
	const submitAddOrChange = async (data: any) => {
		try{
			clearErrorsAddOrChange();
			modalAddOrChange.current?.setLoadingButton();
			
			await addAndChangeSchema(translate).validate({...data, efa001Ativo: data.efa001Ativo ? data.efa001Ativo : ""}, {
				abortEarly: false
			});

			if(onCallback.current)
				onCallback.current(data.cause);

			modalAddOrChange.current?.resetLoadingButton();
			modalAddOrChange.current?.closeModal();

		}catch(err){

			modalAddOrChange.current?.resetLoadingButton();
			if(getValidationErrors(err, setErrorAddOrChange))
				return;

			standardErrorMessages(err, isAdd ? translate("Erro ao adicionar causa") : translate("Erro ao alterar causa"), addToast);
		}
	};
	const actionButtonAdd = (onCallbackFn?: Function) => {
		resetAddOrChange(); 
		setDefaultCause(""); 
		setIsAdd(true); 
		setTitle(translate("Adicionar causa"));
		onCallback.current = onCallbackFn;
		modalAddOrChange.current?.openModal();
	};
	const actionButtonChange = (defaultValue: string, onCallbackFn?: Function) => {
		resetAddOrChange(); 
		setDefaultCause(defaultValue); 
		setIsAdd(false); 
		setTitle(translate("Alterar causa"));
		onCallback.current = onCallbackFn;
		modalAddOrChange.current?.openModal(); 
	};

	useImperativeHandle(ref, () => ({
		actionButtonAdd,
		actionButtonChange
	}));
    
	return (
		<>
			{/* Modal ADD/CHANGE */}
			<DeleteModal
				ref={modalAddOrChange}
				title= {title}
				onSubmit = {handleSubmitAddOrChange(submitAddOrChange)} 
				height="230px"
				isInfo
			>
				<RCCGrid
					container
					item
					xs={10}
				>
					<RCCInput 
						register={registerAddOrChange}
						name="cause"
						label={translate("Causa")}
						defaultValue={defaultCause}
						error={errorsAddOrChange.cause}
						required
					/>
				</RCCGrid>
			</DeleteModal>
		</>
	);
};

export default forwardRef(FishBoneModals);
